<template>
  <div class="waiting-page">
    <div class="container"></div>
  </div>
</template>
<style lang="scss" scoped>
.waiting-page {
  .container {
    min-height: calc(100vh - 100px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error-container {
    color: red;
    width: 100%;
    max-width: 640px;
    text-align: center;
    background: #efefef;
    padding: 1rem 2rem;
  }
}
</style>
<script>
export default {
  beforeMount() {
    const { mobile, cookie } = this.$route.query;
    const extraParams = {};
    if (typeof mobile !== "undefined" && mobile !== null) {
      extraParams["mobile"] = mobile;
    }
    if (typeof cookie !== "undefined" && cookie !== null) {
      extraParams["cookie"] = cookie;
    }
    const url = this.loginLink(extraParams);
    this.$store.commit("showSpinner");

    // window.location.replace(url);

    window.open(url, "_self");
  },
  methods: {
    generateRandomInteger(low, high) {
      const lowCeil = Math.ceil(low);
      const highFloor = Math.floor(high);
      const randomFloat = lowCeil + Math.random() * (highFloor - lowCeil);

      return Math.floor(randomFloat);
    },
    loginLink(extraParams = {}) {
      const baseUrl = process.env.VUE_APP_IDP_BASE_URL || "";
      const clientId = process.env.VUE_APP_IDP_CLIENT_ID || "";
      const randomState = this.generateRandomInteger(1000000, 20000000);
      const redirectTo = process.env.VUE_APP_IDP_REDIRECT || "";

      const query = Object.keys(extraParams)
        .map(el => {
          return `${el}=${extraParams[el]}`;
        })
        .join("&");

      const url = `${baseUrl}/signIn?client_id=${clientId}&state=${randomState}&redirect_uri=${redirectTo}&response_type=code${
        query ? "&" + query : ""
      }`;
      return url;
    }
  }
};
</script>
